import {InjectionToken} from "@angular/core";
import {Params} from "@angular/router";
import {IExcelDataAbstractOptions, IExcelDataAbstractState} from '@shared/components/excel';

// Inject ------------------------------------
export const IMPORT_CUSTOM_DATA_CONST = 'IMPORT_CUSTOM_DATA';

export const IMPORT_CUSTOM_DATA_INJECT$ = new InjectionToken<any>(IMPORT_CUSTOM_DATA_CONST);


// Interface ------------------------------------------------
export type IOptionsImportDataExcelSetting = IExcelDataAbstractOptions & {
  urlApi: string; // Endpoint API import
  componentHandle: any; // Component xử lý import (chính là các trang import hiện tại đang làm)
  originalHeader?: boolean, // header gốc của sheet
  configModal?: {
    btnSave?: {
      label?: string; // label button 'save'
      icon?: string;
    },
    btnClose?: {
      display?: boolean; // hiển thị button close
    },
    bgFooter?: string;
  }
}

// Load sanh sách sheet trong file
export type IParamsCheckSpreadDataImport = {
  businessId: number,
  spreadId: string,
  spreadUrl: string,
  spreadSheetId: number,
  spreadSheetTitle: string,
  accessTokenId: number
  rowHeaders: string // JSON Encode
  pageSize?: number,
  originalHeader?: number, // header gốc của sheet
}


export type IConfigImportDataGoogleSheet = IExcelDataAbstractState & {
  spreadId: string,
  spreadUrl: string,
  spreadSheetId: number,
  spreadSheetTitle: string,
  headersFinal: Record<string, string>, // Mảng headers của file GGS
  pageSize?: number,
  isFinal?: boolean,
  isImportSubmit?: boolean,
  isRunning?: boolean,
  progressPaginator: {
    page: number,
    totalPages: number,
    totalItems: number,
    totalHandleItems: number, // Tổng số items đã xử lý xong
    isError?: boolean,
  }

  // Thông có khi set từ màn import
  urlApi: string,
  params?: Params
}


export type IImportDataRowHeader = Record<string, {
  key: string,
  value: string
}>

export interface IImportDataHandlersAbstract {
  /**
   * - Hàm validate dữ liệu trước khi import
   * - Logic hàm này theo logic của màn hình
   * */
  onHandlerValidateImportData: (setting: IConfigImportDataGoogleSheet) => boolean;
  /**
   * Hàm Nhận cài đặt và tiến hành import data
   * */
  onHandlerSubmitImportData: (setting: IConfigImportDataGoogleSheet) => void;

  /**
   * Khai báo danh sách headers của file cần kiểm tra
   * */
  onDefineHeadersImportData: () => IImportDataRowHeader;

  /**
   * - Hàm lắng nghe việc modal được tắt
   * - Thường các màn cần reset dữ liệu liên quan thì khai báo thêm
   * */
  onHandlerClosedImportData?: () => void;
}
